<div class="modal fade" id="kt_modal_add_role" tabindex="-1" aria-hidden="true">
	<!--begin::Modal dialog-->
	<div class="modal-dialog modal-dialog-centered modal-fullscreen-lg-down" style="max-width: 95vw; width: 95vw;">
		<!--begin::Modal content-->
		<div class="modal-content">
			<!--begin::Modal header-->
			<div class="modal-header p-3 d-flex justify-content-between bg-secondary">
				<!--begin::Modal title-->
				<h2 class="fw-bold">Add a Role</h2>
				<!--end::Modal title-->
				<!--begin::Close-->
				<div class="btn btn-icon btn-sm btn-active-icon-primary" data-kt-roles-modal-action="close" (click)="closeModal()">
					<i class="ki-duotone ki-cross fs-1">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
				</div>
				<!--end::Close-->
			</div>
			<!--end::Modal header-->
			<!--begin::Modal body-->
			<div class="modal-body scroll-y mx-lg-5 my-7">
				<!--begin::Form-->
				<form id="kt_modal_add_role_form" class="form" [formGroup]="roleForm" (ngSubmit)="onSubmit()">
					<!--begin::Scroll-->
					<div class="d-flex flex-column scroll-y me-n7 pe-7" id="kt_modal_add_role_scroll" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto" data-kt-scroll-dependencies="#kt_modal_add_role_header" data-kt-scroll-wrappers="#kt_modal_add_role_scroll" data-kt-scroll-offset="300px">
						<!--begin::Input group-->
						<div class="fv-row mb-10">
							<!--begin::Label-->
							<label class="fs-5 fw-bold form-label mb-2">
								<span class="required">Role name</span>
							</label>
							<!--end::Label-->
							<!--begin::Input-->
							<input
								class="form-control form-control-solid"
								placeholder="Enter a role name"
								formControlName="name"
								[class.is-invalid]="roleForm.get('name')?.invalid && roleForm.get('name')?.touched" />
							<!--end::Input-->
							<!--begin::Error message-->
							<div *ngIf="roleForm.get('name')?.invalid && roleForm.get('name')?.touched" class="invalid-feedback">
								<div *ngIf="roleForm.get('name')?.errors?.['required']">Role name is required</div>
							</div>
							<!--end::Error message-->
						</div>
						<!--end::Input group-->
						<!--begin::Permissions-->
						<div class="fv-row">
							<!--begin::Label-->
							<label class="fs-5 fw-bold form-label mb-2">Role Permissions</label>
							<!--end::Label-->

							<!--begin::Select All-->
							<div class="mb-5 p-3 bg-light rounded">
								<label class="form-check form-check-custom form-check-solid">
									<input
										class="form-check-input"
										type="checkbox"
										formControlName="select_all"
										id="kt_roles_select_all"
										(change)="onSelectAllChange($event)" />
									<span class="form-check-label fw-bold text-gray-800">
										Administrator Access - Select All
										<span class="ms-2" data-bs-toggle="popover" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Allows a full access to the system">
											<i class="ki-duotone ki-information fs-7">
												<span class="path1"></span>
												<span class="path2"></span>
												<span class="path3"></span>
											</i>
										</span>
									</span>
								</label>
							</div>
							<!--end::Select All-->

							<!--begin::Hierarchical Permissions-->
							<div class="accordion" id="permissionsAccordion" formGroupName="permissions">
								<!--begin::Parent Group-->
								<div *ngFor="let parent of parentGroups; let parentIndex = index" class="mb-6">
									<!--begin::Parent Header-->
									<div class="parent-module-header bg-primary p-4 rounded-top d-flex align-items-center justify-content-between cursor-pointer" (click)="toggleParent(parent)">
										<div class="d-flex align-items-center">
											<i class="ki-duotone ki-category me-3 fs-1 text-white">
												<span class="path1"></span>
												<span class="path2"></span>
												<span class="path3"></span>
												<span class="path4"></span>
											</i>
											<h3 class="text-white fw-bolder mb-0 fs-2">{{parent}}</h3>
										</div>
										<i class="ki-duotone fs-1 text-white" [class.ki-down]="expandedParents[parent]" [class.ki-right]="!expandedParents[parent]">
											<span class="path1"></span>
											<span class="path2"></span>
										</i>
									</div>
									<!--end::Parent Header-->

									<!--begin::Parent Content-->
									<div class="parent-module-content bg-light p-5 rounded-bottom border border-primary border-top-0" *ngIf="expandedParents[parent]">
											<!--begin::Modules in Parent-->
											<div *ngFor="let module of groupedModules[parent]; let moduleIndex = index" class="mb-4">
												<!--begin::Module Card-->
												<div class="card shadow-sm border-start border-4">
													<!--begin::Module Header-->
													<div class="card-header bg-light py-3 border-bottom">
														<h6 class="card-title mb-0 d-flex align-items-center">
															<i class="ki-duotone ki-element-11 me-2 fs-3 text-danger">
																<span class="path1"></span>
																<span class="path2"></span>
																<span class="path3"></span>
																<span class="path4"></span>
															</i>
															<span class="fw-bold text-gray-800">{{module.name}}</span>
														</h6>
													</div>
													<!--end::Module Header-->

													<!--begin::Module Body-->
													<div class="card-body p-5">
														<!--begin::Module Select All-->
														<div class="mb-4">
															<label class="form-check form-check-custom form-check-solid">
																<input
																	class="form-check-input"
																	type="checkbox"
																	[id]="'module_select_all_' + getModuleSlug(module)"
																	[checked]="isModuleAllSelected(module)"
																	(change)="onModuleSelectAllChange(module, $event)" />
																<span class="form-check-label fw-semibold text-gray-700">
																	Select All
																</span>
															</label>
														</div>
														<!--end::Module Select All-->

														<!--begin::Module Permissions-->
														<div *ngIf="getModuleSlug(module)" [formGroupName]="getModuleSlug(module)">
															<div class="d-flex flex-wrap gap-4">
																<!--begin::Checkbox - Add-->
																<label class="form-check form-check-custom form-check-solid">
																	<input
																		class="form-check-input"
																		type="checkbox"
																		formControlName="add"
																		[id]="getModuleSlug(module) + '_add'"
																		(change)="onModulePermissionChange(module, 'add', $event)" />
																	<span class="form-check-label text-gray-700">Add</span>
																</label>
																<!--end::Checkbox-->
																<!--begin::Checkbox - Edit-->
																<label class="form-check form-check-custom form-check-solid">
																	<input
																		class="form-check-input"
																		type="checkbox"
																		formControlName="edit"
																		[id]="getModuleSlug(module) + '_edit'"
																		(change)="onModulePermissionChange(module, 'edit', $event)" />
																	<span class="form-check-label text-gray-700">Edit</span>
																</label>
																<!--end::Checkbox-->
																<!--begin::Checkbox - View-->
																<label class="form-check form-check-custom form-check-solid">
																	<input
																		class="form-check-input"
																		type="checkbox"
																		formControlName="view"
																		[id]="getModuleSlug(module) + '_view'"
																		(change)="onModulePermissionChange(module, 'view', $event)" />
																	<span class="form-check-label text-gray-700">View</span>
																</label>
																<!--end::Checkbox-->

																<!--begin::Extra Permissions for Parent Module-->
																<ng-container *ngIf="module.extra && module.extra.length > 0">
																	<label
																		*ngFor="let extraSlug of module.extra"
																		class="form-check form-check-custom form-check-solid extra-permission">
																		<input
																			class="form-check-input"
																			type="checkbox"
																			[formControlName]="extraSlug"
																			[id]="getModuleSlug(module) + '_' + extraSlug"
																			(change)="onModulePermissionChange(module, extraSlug, $event)" />
																		<span class="form-check-label text-warning fw-semibold">
																			{{extraSlug.replace('-', ' ') | titlecase}}
																		</span>
																	</label>
																</ng-container>
																<!--end::Extra Permissions for Parent Module-->
															</div>
														</div>
														<!--end::Module Permissions-->

												<!--begin::Children Section-->
												<div *ngIf="module.children && module.children.length > 0" class="mt-5">
													<h6 class="text-gray-600 fw-semibold mb-3 text-uppercase" style="font-size: 0.85rem; letter-spacing: 0.5px;">Sub-Modules</h6>
													<div class="ms-5">
														<div *ngFor="let child of module.children; let last = last" class="mb-4 pb-4" [class.border-bottom]="!last" [class.border-gray-300]="!last">
															<!--begin::Child Header-->
															<div class="d-flex align-items-center mb-3">
																<i class="ki-duotone ki-arrow-right me-2 fs-4 text-primary">
																	<span class="path1"></span>
																	<span class="path2"></span>
																</i>
																<span class="fw-bold text-gray-800 fs-6">{{child.name}}</span>
															</div>
															<!--end::Child Header-->

															<!--begin::Child Permissions-->
															<div class="ms-8" [formGroupName]="child.slug">
																<div class="d-flex flex-wrap gap-4">
																	<!--begin::Checkbox - Add-->
																	<label class="form-check form-check-custom form-check-solid">
																		<input
																			class="form-check-input"
																			type="checkbox"
																			formControlName="add"
																			[id]="child.slug + '_add'"
																			(change)="onChildPermissionChange(module, child.slug, 'add', $event)" />
																		<span class="form-check-label text-gray-700">Add</span>
																	</label>
																	<!--end::Checkbox-->
																	<!--begin::Checkbox - Edit-->
																	<label class="form-check form-check-custom form-check-solid">
																		<input
																			class="form-check-input"
																			type="checkbox"
																			formControlName="edit"
																			[id]="child.slug + '_edit'"
																			(change)="onChildPermissionChange(module, child.slug, 'edit', $event)" />
																		<span class="form-check-label text-gray-700">Edit</span>
																	</label>
																	<!--end::Checkbox-->
																	<!--begin::Checkbox - View-->
																	<label class="form-check form-check-custom form-check-solid">
																		<input
																			class="form-check-input"
																			type="checkbox"
																			formControlName="view"
																			[id]="child.slug + '_view'"
																			(change)="onChildPermissionChange(module, child.slug, 'view', $event)" />
																		<span class="form-check-label text-gray-700">View</span>
																	</label>
																	<!--end::Checkbox-->

																	<!--begin::Extra Permissions-->
																	<ng-container *ngIf="child.extra && child.extra.length > 0">
																		<label
																			*ngFor="let extraSlug of child.extra"
																			class="form-check form-check-custom form-check-solid extra-permission">
																			<input
																				class="form-check-input"
																				type="checkbox"
																				[formControlName]="extraSlug"
																				[id]="child.slug + '_' + extraSlug"
																				(change)="onChildPermissionChange(module, child.slug, extraSlug, $event)" />
																			<span class="form-check-label text-warning fw-semibold">
																				{{extraSlug.replace('-', ' ') | titlecase}}
																			</span>
																		</label>
																	</ng-container>
																	<!--end::Extra Permissions-->
																</div>
															</div>
															<!--end::Child Permissions-->
														</div>
													</div>
												</div>
												<!--end::Children Section-->
										</div>
										<!--end::Module Body-->
									</div>
									<!--end::Module Card-->
								</div>
								<!--end::Modules in Parent-->
							</div>
							<!--end::Parent Content-->
						</div>
						<!--end::Parent Group-->
							</div>
							<!--end::Hierarchical Permissions-->
						</div>
						<!--end::Permissions-->
					</div>
					<!--end::Scroll-->
					<!--begin::Actions-->
					<div class="text-center pt-15">
						<button type="reset" class="btn btn-light me-3" data-kt-roles-modal-action="cancel">Discard</button>
						<button type="submit" class="btn btn-primary indicator" [disabled]="isLoading" style="min-width: 120px;" data-kt-roles-modal-action="submit">
							<span class="indicator-label" *ngIf="!isLoading">Add Role</span>
							<span class="indicator-progress" *ngIf="isLoading">
								Please wait...
								<span class="spinner-border spinner-border-sm align-middle ms-2"></span>
							</span>
						</button>
					</div>
					<!--end::Actions-->
				</form>
				<!--end::Form-->
			</div>
			<!--end::Modal body-->
		</div>
		<!--end::Modal content-->
	</div>
	<!--end::Modal dialog-->
</div>
